import { z } from 'zod';

import { createDateSchemaWithDefinedMinAndMaxBankValues } from '../../../../../../../../helpers/zod/createDateSchemaWithDefinedMinAndMaxBankValues';
import { validateDateRange } from '../../../../../../../../helpers/zod/validateDateRange';
import { ExtendedBankIdEventType } from '../const';

export type PrivateCompaniesPageFilterFormErrorMessages = {
	dateCantBeEarlierThanBankInceptionDateError: string;
	dateMustBeTodayAtLatestError: string;
	dateToMustBeBeforeDateFromError: string;
};

export const PRIVATE_COMPANIES_FILTER_DEFAULT_VALUES: PrivateCompaniesPageFilterForm =
	{
		eventTimeFrom: null,
		eventTimeTo: null,
		type: undefined,
	};

export const getPrivateCompaniesPageFilterFormSchema = (
	errorMessages?: PrivateCompaniesPageFilterFormErrorMessages,
) => {
	const schema = z
		.object({
			eventTimeFrom: createDateSchemaWithDefinedMinAndMaxBankValues({
				maxDateErrorMessage: errorMessages?.dateMustBeTodayAtLatestError,
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
			}),
			eventTimeTo: createDateSchemaWithDefinedMinAndMaxBankValues({
				maxDateErrorMessage: errorMessages?.dateMustBeTodayAtLatestError,
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
			}),
			type: z.enum(ExtendedBankIdEventType).optional(),
		})
		.superRefine(({ eventTimeFrom, eventTimeTo }, ctx) => {
			validateDateRange(
				eventTimeFrom,
				eventTimeTo,
				errorMessages?.dateToMustBeBeforeDateFromError,
				ctx,
				'eventTimeTo',
			);
		});

	return schema;
};
export type PrivateCompaniesPageFilterForm = z.infer<
	ReturnType<typeof getPrivateCompaniesPageFilterFormSchema>
>;
